<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <img
            class="card-img-top"
            :src="require('../assets/images/rentini-landing-banner.gif')"
            alt="Card image cap"
          />
          <div class="card-body text-center">
            <h4 class="card-title">
              บริการใหม่ ช่วยให้หอพักของคุณเป็นที่หมายปอง
              และได้รับความสนใจจากผู้คนจำนวนมาก
              เพิ่มศักยภาพการเข้าถึงแหล่งความต้องการเช่าหอพักได้ตรงจุด
              ทำให้โอกาสการปิดการขายเพิ่มสูงขึ้น
            </h4>
            <h5 class="card-text" style="margin-top: 30px">
              <a target="_blank" href="https://www.rentini.in.th">
                คลิกเพื่อดูเว็บไซต์
              </a>
            </h5>
            <hr />
            <h4 class="text-center">รายละเอียดแพ็คเกจ</h4>
            <img
              class="img-fluid"
              :src="require('../assets/images/rentini-pack.png')"
              alt=""
              srcset=""
            />
            <div v-if="apartment">
              <div
                v-if="!isValidApartment"
                class="alert alert-secondary mt-3"
                role="alert"
              >
                ขออภัย บริการนี้สำหรับตึกที่ใช้งานแพ็คเกจ Professional Package
                หรือ Business Package เท่านั้น
              </div>
              <button
                type="button"
                class="btn btn-lg btn-success"
                @click="goToSetting()"
                :disabled="!isValidApartment"
              >
                ฉันสนใจที่จะใช้บริการนี้
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      apartmentId: this.$route.params.apartmentId,
      apartment: null,
      isValidApartment: false,
    };
  },
  async mounted() {
    try {
      let query = new this.Parse.Query("Apartment");
      query.include("package");
      this.apartment = await query.get(this.apartmentId);
      if (
        this.apartment.get("package").get("code") === "business" ||
        this.apartment.get("package").get("code") === "pro"
      ) {
        this.isValidApartment = true;
      }
    } catch (error) {}
    try {
      this.addRentiniLog("landing");
    } catch (ex) {}
  },
  methods: {
    goToSetting() {
      try {
        this.addRentiniLog("interested");
      } catch (error) {}
      this.$router.push({
        name: "ApartmentRegister",
        params: { apartmentId: this.apartmentId },
      });
    },
    addRentiniLog(activity) {
      return this.axios({
        url: `${process.env.VUE_APP_RENTINI_PARTNER_PARSE_SERVER_URL}/functions/addRentiniLog`,
        method: "POST",
        data: {
          apartmentId: this.apartmentId,
          userId: this.Parse.User.current().id,
          activity: activity,
        },
        headers: {
          "X-Parse-Application-Id":
            process.env.VUE_APP_RENTINI_PARTNER_PARSE_APP_ID,
          "Content-Type": "application/json",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin-top: 50px;
  margin-bottom: 150px;
}
</style>